<template>
  <div>
    <b-modal
      id="modal-change-client"
      ref="modal-change-client"
      centered
      :title="$t('DEBTIA_CHANGE_CASE_CLIENT')"
      :ok-title="$t('DEBTIA_UPDATE')"
      :no-close-on-backdrop="true"
      cancel-variant="outline-secondary"
      size="lg"
      :ok-disabled="disabled"
      @show="resetModal"
      @hidden="resetModal"
      @ok="confirmation"
    >
      <b-overlay
        id="overlay-background"
        :show="loader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-alert
          v-if="errorMsg"
          variant="warning"
          show
        >
          <div class="alert-body">
            <span>{{ errorMsg }}</span>
          </div>
        </b-alert>
        <b-form
          ref="form"
          class="repeater-form dd"
          @submit.prevent="repeatAgain"
        >
          <!-- Row Loop -->
          <b-row
            ref="row"
          >
            <!-- Cost -->
            <b-col
              md="6"
              offset-md="3"
              class="p-0"
            >
              <b-form-group
                :label="$t('DEBTIA_CLIENT')"
                label-for="creditor"
              >
                <v-select
                  v-model="selectedClient"
                  class="creditor_id"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="clientsOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="creditor_id"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <div
            v-if="!debtorsBelongToCompany"
          >
            <hr>
            <b-row
              v-for="(debtorItem, index) in caseDebtors"
              :id="index"
              :key="index"
              ref="row"
            >
              <!-- Old Debtor -->
              <b-col
                md="5"
              >
                <b-form-group
                  :label="$t('DEBTIA_OLD_DEBTOR')"
                  label-for="old_debtor_id"
                >
                  <v-select
                    v-model="debtorItem.old_debtor_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    class="old_debtor_id"
                    :options="debtorsOptions"
                    :reduce="val => val.value"
                    :clearable="false"
                    input-id="old_debtor_id"
                    :disabled="true"
                    :aria-selected="true"
                  />
                </b-form-group>
              </b-col>
              <!-- New Debtor -->
              <b-col
                md="5"
              >
                <b-form-group
                  :label="$t('DEBTIA_NEW_DEBTOR')"
                  label-for="new_debtor_id"
                >
                  <v-select
                    v-model="debtorItem.new_debtor_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    class="new_debtor_id"
                    :options="debtorsOptions"
                    :reduce="val => val.value"
                    :clearable="false"
                    input-id="new_debtor_id"
                    @input="changeNewDebtor($event, index, item.new_debtor_id)"
                  />
                </b-form-group>
              </b-col>
              <!-- Main Debtor -->
              <b-col
                md="2"
              >
                <b-form-group
                  :label="$t('DEBTIA_MAIN_DEBTOR')"
                  label-for="is_main_debtor"
                >
                  <b-form-checkbox
                    v-model="debtorItem.is_main_debtor"
                    plain
                    class="custom-control-primary"
                    style="white-space: nowrap"
                    @change="validateMainDebtorItems(caseDebtors)"
                  >
                    {{ $t('DEBTIA_IS_MAIN_DEBTOR') }}
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <hr>
              </b-col>
            </b-row>
            <b-button
              v-if="caseDebtors.length < debtorsOptions.length"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="repeatAgain"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add New</span>
            </b-button></div>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BButton,
  BForm,
  BAlert, BOverlay,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import axios from '@axios'
import vSelect from 'vue-select'
import i18n from '@/libs/i18n'

export default {
  components: {
    vSelect,
    BOverlay,
    BAlert,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    caseId: {
      type: [Number, String],
      required: true,
    },
    creditorId: {
      type: Number,
      required: true,
    },
    getDetails: {
      type: Function,
      required: true,
    },
    getDebtCaseDebtors: {
      type: Array,
      required: true,
    },
    clientDebtorsOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loader: false,
      disabled: true,
      debtorsBelongToCompany: localStorage.getItem('debtorsBelongTo') === 'company',
      required,
      errorMsg: '',
      selectedClient: 0,
      clientsOptions: [],
      clientIndex: 1,
      item: {
        recordIndex: 1,
        creditor_id: 0,
        debt_case_id: 0,
        debtors: [],
      },
      caseDebtors: [],
      debtorsOptions: [],
      debtorIndex: 1,
      debtorItems: [
        {
          recordIndex: 1,
          old_debtor_id: 0,
          new_debtor_id: 0,
          is_main_debtor: false,
        },
      ],
    }
  },
  watch: {
    selectedClient: {
      deep: true,
      handler(newValue) {
        if (this.creditorId !== newValue) {
          this.disabled = false
        }
        this.errorMsg = ''
        this.getDebtorsOptions(newValue)
      },
    },
    getDebtCaseDebtors: {
      handler() {
        this.oldDebtCaseDebtor()
      },
    },
  },
  created() {
    this.getClientsOptions()
  },
  methods: {
    getClientsOptions() {
      this.clientsLoader = true
      const url = '/clients/dropdown'
      axios.get(url).then(response => {
        if (response.status === 200) {
          this.selectedClient = this.creditorId
          this.clientsOptions = [{ label: 'Select Client', value: 0 }, ...response.data.data]
          this.debtorsOptions = this.clientDebtorsOptions
        }
      })
    },
    getDebtorsOptions(id) {
      const url = `/debtor/dropdown?client_id=${id}`
      axios.get(url).then(response => {
        if (response.status === 200) {
          this.debtorsOptions = response.data.data
          if (!this.debtorsBelongToCompany && id !== this.creditorId) {
            this.caseDebtors = [{
              recordIndex: this.debtorIndex,
              old_debtor_id: 0,
              new_debtor_id: 0,
              is_main_debtor: false,
            }]
          }
        }
      })
    },
    resetModal() {
      this.clientIndex = 1
      this.errorMsg = ''
      this.item = {
        recordIndex: 1,
        creditor_id: 0,
        debt_case_id: 0,
        debtors: [],
      }
    },
    isNotEmptyArray(variable) {
      if (Array.isArray(variable) && variable.length > 0) {
        return !variable.some(item => Array.isArray(item) && item.length === 0)
      }
      return false
    },
    confirmation(evt) {
      evt.preventDefault()
      this.errorMsg = ''
      if (this.selectedClient === this.creditorId) {
        this.errorMsg = 'Select a creditor to make changes'
        return false
      }
      if (!this.debtorsBelongToCompany) {
        this.validateDebtorsItems(this.caseDebtors)
        const isValid = this.validateMainDebtorItems(this.caseDebtors)
        if (!isValid) {
          this.errorMsg = 'One main debtor should be selected!'
          return false
        }
      }
      if (!this.debtorsBelongToCompany && this.isNotEmptyArray(this.caseDebtors) === false) {
        this.errorMsg = 'Add at least one debtor!'
        return false
      }
      if (!this.errorMsg) {
        this.$swal({
          title: i18n.t('DEBTIA_CAUTION'),
          text: i18n.t('DEBTIA_CHANGE_CASE_CLIENT_MSG'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: i18n.t('DEBTIA_YES'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            this.changeCaseClient()
          }
        })
      }
      return true
    },
    validateDebtorsItems(debtorItems) {
      for (const item of debtorItems) {
        if (item.new_debtor_id === 0) {
          this.errorMsg = 'Debtor should be selected!'
          return false
        }
      }
      return true // Validation passes if there is at most one item with is_main_debtor set to true
    },
    validateMainDebtorItems(debtorItems) {
      let countMainDebtors = 0
      for (const item of debtorItems) {
        if (item.is_main_debtor === true) {
          countMainDebtors += 1
          if (countMainDebtors > 1) {
            this.errorMsg = 'Only one debtor can be marked as main!'
            return false // return false // Validation fails if more than one item has is_main_debtor set to true
          }
        }
      }
      if (countMainDebtors === 0) {
        this.errorMsg = 'One main debtor should be selected!'
        return false // Validation fails if more than one item has is_main_debtor set to true
      }
      return true// Validation passes if there is at most one item with is_main_debtor set to true
    },
    changeCaseClient() {
      this.errorMsg = ''
      this.loader = true
      const url = '/change-debt-case-creditor'
      this.item.debt_case_id = this.caseId
      this.item.creditor_id = this.selectedClient
      if (!this.debtorsBelongToCompany) {
        this.item.debtors = this.caseDebtors
      }
      // if (!this.debtorsBelongToCompany && id !== this.creditorId) {
      //   this.caseDebtors = []
      // }
      const data = { ...this.item }
      axios.post(url, data).then(response => {
        this.loader = false
        if (response.status === 200) {
          this.$refs['modal-change-client'].hide()
          this.getDetails()
        }
      }).catch(error => {
        this.loader = false
        this.errorMsg = error.response.data.message ? error.response.data.message : error.message
      })
    },
    changeNewDebtor(event, index, newDebtorId) {
      let exists = false
      let debtorExist = false
      const existingNewDebtors = []
      this.caseDebtors.forEach(element => {
        if (element.old_debtor_id === newDebtorId) {
          exists = true
        }
        if (!existingNewDebtors.includes(element.new_debtor_id)) {
          if (element.new_debtor_id > 0) {
            existingNewDebtors.push(element.new_debtor_id)
          }
          debtorExist = false
        } else {
          debtorExist = true
        }
      })
      if (exists === true) {
        this.caseDebtors[index].new_debtor_id = 0
      }
      if (debtorExist === true) {
        this.caseDebtors[index].new_debtor_id = 0
      }
    },
    oldDebtCaseDebtor() {
      const debtors = []
      this.getDebtCaseDebtors.forEach((element, index) => {
        let isMainDebtor = false
        if (element.is_main_debtor === 1) {
          isMainDebtor = true
        }
        const obj = {
          recordIndex: index + 1,
          old_debtor_id: element.debtor_id,
          new_debtor_id: 0,
          is_main_debtor: isMainDebtor,
        }
        debtors.push(obj)
      })
      this.caseDebtors = [...debtors]
    },
    repeatAgain() {
      this.debtorIndex += 1
      const obj = {
        recordIndex: this.debtorIndex,
        old_debtor_id: 0,
        new_debtor_id: 0,
        is_main_debtor: false,
      }
      this.caseDebtors.push(obj)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss">
.modal-lg {
  max-width: 1000px;
}
</style>
